import styled from 'styled-components';
export const InputContainer = styled.div `
  display: flex;
  align-items: flex-end;
  position: relative;
`;
export const OptionFlag = styled.img `
  margin-right: 15px;
  height: 17px;
  width: 28px;
`;
export const OptionContainer = styled.div `
  text-align: left;
`;
export const TextWrapper = styled.div `
  position: absolute;
  bottom: 0px;
  left: 0px;
`;
export const OptionLabel = styled.span `
  font-weight: 400;
`;
export const HelperText = styled.div `
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.grey48};
`;
export const Prefijo = styled.div `
  padding-right: 12px;
  min-width: 155px;
`;
export const Numero = styled.div `
  flex-grow: 1;
`;
export const Label = styled.div `
  ${({ required }) => required
    ? `:after {
      content: ' *';
      color: red;
    }`
    : ''}
`;
export const ErrorText = styled(HelperText) `
  color: ${({ theme }) => theme.colors.danger.normal};
`;
